module.exports = __webpack_public_path__ + "img/qu_cm.360fb24.jpg";